module.exports = __webpack_public_path__ + "static/media/Facebook-color.78b0e2c3.svg";